import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <span className="text-xl font-heading font-semibold tracking-wider text-background-50 whitespace-nowrap cursor-pointer">
                  长日光阴
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/60">
                珍藏每一寸慢时光。<br />
                用文字、影像与生活美学，<br />
                找回被快节奏吞噬的从容与诗意。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">内容分类</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/slow-living" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">慢生活</Link>
                <Link to="/category/time-records" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">时光记录</Link>
                <Link to="/category/life-aesthetics" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">生活美学</Link>
                <Link to="/category/sense-of-years" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">岁月感</Link>
                <Link to="/category/healing-life" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">治愈系生活</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">品牌故事</Link>
                <a href="/about#reputation" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">用户口碑</a>
                <a href="/about#contact" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
                <a href="/about#faq" className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">关注我们</h4>
              <p className="text-sm text-background-50/60 mb-4 leading-relaxed">
                订阅我们的慢时光通讯，<br />
                每周收到一封温暖来信。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg text-background-50/80"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg text-background-50/80"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-reddit-line text-lg text-background-50/80"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 长日光阴. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/40 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}